import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-deactive-restaurant',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './deactive-restaurant.component.html',
  styleUrl: './deactive-restaurant.component.css',
})
export class DeactiveRestaurantComponent {
  status = inject(ActivatedRoute).snapshot.params['status'] as string;
  private router = inject(Router);
  private authService = inject(AuthService);

  protected signOut(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}
